export function localCompareEnglish(a: string, b: string): number {
  return a.localeCompare(b, 'en');
}
